import { useState } from 'react';
import type { CSSProperties } from 'react';

/**
 * Une action destructrice en DEUX gestes : un pouce qui glisse ne doit rien detruire.
 *
 * Le motif existait deja a trois endroits (retrait d'un element de liste, retrait d'une
 * personne, « passer ce jour ») ; il vit ici pour les gestes qui en manquaient — refuser
 * une proposition, vider un repas, couper les notifications, deconnecter Google.
 */
export function BoutonDeuxGestes({
  libelle,
  libelleArme,
  aria,
  ariaArme,
  onConfirmer,
  occupe = false,
  style,
  styleArme,
}: {
  libelle: string;
  libelleArme: string;
  aria: string;
  ariaArme: string;
  onConfirmer: () => void;
  occupe?: boolean;
  style?: CSSProperties;
  /** Styles ajoutes une fois arme (une couleur d'alerte, en general). */
  styleArme?: CSSProperties;
}) {
  const [arme, setArme] = useState(false);

  return (
    <button
      type="button"
      className="pressable"
      disabled={occupe}
      aria-label={arme ? ariaArme : aria}
      onClick={() => {
        if (arme) {
          setArme(false);
          onConfirmer();
        } else {
          setArme(true);
        }
      }}
      // Sans ce desarmement, un bouton arme puis abandonne resterait piege en position
      // « un clic de plus et ca part ».
      onBlur={() => setArme(false)}
      style={{ ...style, ...(arme ? styleArme : undefined) }}
    >
      {arme ? libelleArme : libelle}
    </button>
  );
}
